import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../../../core/http.service';
import { BaseRepositoryImpl } from '../../base-repository-impl';
import { EmployeeDailyAbsentRepository } from '../../../../domain/interfaces/repositories/HrManagment/attendance/att-employee-daily-absent-repository.interface';
import { AttEmployeeDailyAbsentModel, AttEmployeeDailyAbsentResponse } from '../../../../domain/models/Hr-Management/attendance/att-employee-daily-absent.model';


@Injectable({
  providedIn: 'root',
})
export class EmployeeDailyAbsentRepositoryImplService
  extends BaseRepositoryImpl<
     AttEmployeeDailyAbsentModel,
     AttEmployeeDailyAbsentResponse
  >
  implements EmployeeDailyAbsentRepository {

  constructor(http: HttpService) {
    super(http, 'AttEmployeeDailyAbsent/');
  }

  getFiltered(filters: {
    companyId?: string;
    employeeId?: number;
    absentDate?: string;
    attAbsentId?: number;
    type?: number;
    status?: number;
    fromDate?: string;
    toDate?: string;
    page?: number;
    pageSize?: number;
  }): Observable< AttEmployeeDailyAbsentResponse> {

    const params = new URLSearchParams();

    if (filters.companyId) params.append('companyId', filters.companyId);
    if (filters.employeeId !== undefined)
      params.append('EmployeeId', filters.employeeId.toString());
    if (filters.absentDate)
      params.append('AbsentDate', filters.absentDate);
    if (filters.attAbsentId !== undefined)
      params.append('AttAbsentId', filters.attAbsentId.toString());
    if (filters.type !== undefined)
      params.append('Type', filters.type.toString());
    if (filters.status !== undefined)
      params.append('Status', filters.status.toString());
    if (filters.fromDate) params.append('FromDate', filters.fromDate);
    if (filters.toDate) params.append('ToDate', filters.toDate);

    params.append('page', (filters.page ?? 1).toString());
    params.append('pageSize', (filters.pageSize ?? 10).toString());

    return this.http.getData< AttEmployeeDailyAbsentResponse>(
      `${this.baseUrl}GetWithFilter?${params.toString()}`
    );
  }


  /** att_review_01: a percentage set by hand on a 0% "no rule" row (needs the Approve permission; approves the row; audited). */
  setManualPercent(id: number, percent: number): Observable<AttEmployeeDailyAbsentResponse> {
    return this.http.putData<any, AttEmployeeDailyAbsentResponse>(`${this.baseUrl}ManualPercent?id=${id}&percent=${percent}`, {});
  }

/** att_review_02: one decision (approve / reject / back to pending) with an optional note; needs the Approve right. */
  decide(id: number, status: number, note: string, asAdjustment = false): Observable<AttEmployeeDailyAbsentResponse> {
    return this.http.putCoded<any, AttEmployeeDailyAbsentResponse>(`${this.baseUrl}UpdateStatus`, { id, status, note, asAdjustment });
  }

  /** att_review_02: decides many rows at once (all or nothing). */
  decideMany(ids: number[], status: number, note: string, asAdjustment = false): Observable<any> {
    return this.http.putCoded<any, any>('Attendance/decisions', { ids, kind: 'absence', status, note, asAdjustment });
  }

}
